import moment from 'moment'
function deepCopy (obj) {
  const copyObj = Array.isArray(obj) ? [] : {}
  for (var key in obj) {
    copyObj[key] = typeof (obj[key]) === 'object' ? deepCopy(obj[key]) : obj[key]
  }
  return copyObj
}

const sesstionStore = {
  set (key, val) {
    window.sessionStorage.setItem(key, JSON.stringify(val))
  },
  get (key) {
    const result = window.sessionStorage.getItem(key)
    if (result) {
      return JSON.parse(result)
    }
    return undefined
  },
  remove (key) {
    return window.sessionStorage.removeItem(key)
  },
  clear () {
    window.sessionStorage.clear()
  }
}

let _scrollTop
class ModalHelper {
  // popup 显示时调用
  static afterOpen () {
    _scrollTop = document.scrollingElement.scrollTop
    document.body.style.position = 'fixed'
    document.body.style.top = -_scrollTop + 'px'
  }

  // popup 关闭时调用
  static beforeClose () {
    document.body.style.position = ''
    document.body.style.top = ''
    // 使 scrollTop 恢复原状
    document.scrollingElement.scrollTop = _scrollTop
  }
}

const formateDate = dataStr => moment(dataStr).format('YYYY-MM-DD HH:mm')

export default ModalHelper

export {
  deepCopy,
  sesstionStore,
  ModalHelper,
  formateDate
}
